export default __webpack_public_path__ + "static/media/logo192.a307f347.png";